import React, { Component } from 'react'
import PropTypes from 'prop-types'
import t from 'tcomb-form'
import { emailValidation } from '../../../Lib/FormUtils'
import I18n from '../../../i18n/i18n'
import FullScreenLoader from '../../../Components/UI/Loaders/FullScreenLoader'
import ContentCard from '../../../Components/UI/ContentCards/ContentCard'
import FormCard from '../../../Components/UI/ContentCards/FormCard'

export default class BillingInfoForm extends Component {

  static propTypes = {
    user: PropTypes.object,
    fetching: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  static defaultProps = {
    user: null,
    fetching: false,
    onSubmit: null
  }

  constructor(props) {
    super(props)
    this.state = {
      value: {
        name: '',
        address: '',
        street2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        email: ''
      }
    }
  }

  componentDidMount = () => {
    const { user } = this.props
    if (user) {
      const { address: userAddress = {} } = user
      const { name = '', address = '', street2 = '', city = '', state = '', country = '', zip = '', email = '' } = userAddress
      this.setState({
        value: {
          name,
          address,
          street2,
          city,
          state,
          country,
          zip,
          email
        }
      })
    }
  }

  getFields = () => {
    return {
      name: t.String,
      address: t.String,
      street2: t.String,
      city: t.String,
      state: t.String,
      country: t.String,
      zip: t.String,
      email: t.refinement(t.String, emailValidation)
    }
  }

  getFieldsOptions = () => {
    return {
      name: {
        label: I18n.t('shared.name')
      },
      address: {
        label: I18n.t('shared.documentNumber')
      },
      street2: {
        label: I18n.t('shared.street')
      },
      city: {
        label: I18n.t('shared.city')
      },
      state: {
        label: I18n.t('shared.province')
      },
      country: {
        label: I18n.t('shared.country')
      },
      zip: {
        label: I18n.t('shared.zipCode')
      },
      email: {
        label: I18n.t('shared.emailBilling')
      }
    }
  }

  onSubmit = () => {
    this.props.onSubmit(this.state.value)
  }

  onChange = (value) => {
    this.setState({ value })
  }

  render = () => {
    return (
      <ContentCard
        renderContent={() => (
          <div className="billingInfoForm">
            <FormCard
              name={'billingInfoForm'}
              title={I18n.t('screens.profile.billingInfo.title')}
              onSubmit={this.onSubmit}
              onChange={this.onChange}
              deleteButton={false}
              fields={this.getFields()}
              fieldsOptions={this.getFieldsOptions()}
              value={this.state.value}
              fetching={this.props.fetching}
            />
            <FullScreenLoader visible={this.props.fetching}/>
          </div>
        )}
      />
    )
  }

}